<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the LVB specific component for rendering the Duty activity start line (first line in a block)    -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <v-row v-if="isBreak" dense class="DutyActivityStart_RhB">
    <v-col cols="8">
      <div>
        <div>{{ time(dutyActivity.fromMinutesAfterMidnight) }} - {{ time(dutyActivity.toMinutesAfterMidnight) }}</div>
        <div>{{ dutyActivity.longname }}</div>
      </div>
    </v-col>
    <v-col cols="4">
      <div class="mr-6 d-flex justify-end" style="width: 100%; text-align: right">
        {{ dutyActivity.activityShortname }}
        <v-icon class="ml-2" small>mdi-coffee</v-icon>
      </div>
    </v-col>
  </v-row>

  <v-row v-else-if="isOneLiner" dense class="DutyActivityStart_RhB">
    <v-col cols="8">
      <div>
        <div>{{ time(dutyActivity.fromMinutesAfterMidnight) }} - {{ time(dutyActivity.toMinutesAfterMidnight) }}</div>
        <div>{{ dutyActivity.longname }}</div>
      </div>

      <!--      <time-line-point :small="true" :cellHeight="30" :themeName="themeName" :topConnection="false" :bottomConnection="true"></time-line-point>-->
    </v-col>
    <v-col cols="4">
      <div class="pr-1" style="text-align: right; width: 100%">
        <!--        {{ dutyActivity.note !== dutyActivity.activityShortname ? dutyActivity.activityShortname : '' }}-->
        {{ dutyActivity.activityShortname }}
      </div>
    </v-col>
  </v-row>

  <v-row v-else class="DutyActivityStart_RhB">
    <v-col cols="8">
      <div class="d-flex flex-column">
        <div>{{ time(dutyActivity.fromMinutesAfterMidnight) }}</div>
        <div>{{ time(dutyActivity.toMinutesAfterMidnight) }}</div>
      </div>
    </v-col>
    <v-col cols="4" class="relative">
      <div class="flex-table">
        <div class="text-column">{{ dutyActivity._startStop.shortname }}</div>
        <div style="width: 20px">
          <time-line-point
            style="margin-top: 2px !important"
            small
            :cellHeight="37"
            :themeColor="'secondary'"
            themeName="light"
            bottomConnection
          ></time-line-point>
        </div>
      </div>
      <div class="flex-table">
        <div class="text-column">{{ dutyActivity._endStop.shortname }}</div>
        <div style="width: 20px">
          <time-line-point class="mt-1" small topConnection themeColor="secondary" :cellHeight="50"></time-line-point>
        </div>
      </div>
    </v-col>
    <v-col cols="12" v-if="isTrain" class="pl-0">
      <v-btn text rounded @click="displayTrainTeam">
        <v-icon class="ml-0 mr-2">mdi-account-box-outline</v-icon>
        Zugteam
      </v-btn>
    </v-col>
    <!--    <v-col cols="12" v-else class="border-red">-->
    <!--      {{ dutyActivity.activityShortname }}-->
    <!--    </v-col>-->
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';
import { mapState } from 'vuex';
import MODULE_ID from '@/modules/myDuties/moduleId';

export default {
  name: 'DutyActivityStart_RhB',
  components: {
    TimeLinePoint,
  },
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  mounted() {
    console.debug('DutyActivityStart_RhB', this.dutyActivity.activityShortname, this.dutyActivity.note);
  },
  computed: {
    ...mapState(MODULE_ID, ['teams', 'users', 'usersById']),
    isOneLiner() {
      return ['Fussweg', 'ZR'].includes(this.dutyActivity.activityShortname);
    },
    isBreak() {
      return ['P', 'PAUSE'].includes(this.dutyActivity.activityShortname);
    },
    isTrain() {
      return this.dutyActivity.activityShortname === 'Zug';
    },
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
    displayTrainTeam() {
      let trainNr = this.dutyActivity.course;
      let day = this.dutyActivity.day;
      let trainTeam = this.teams
        .filter((team) => {
          return team.trainNr === trainNr && team.day === day;
        })
        .map((teamMember) => {
          let user = this.usersById[teamMember.idUserFk];
          if (user) {
            Object.assign(teamMember, { firstname: user.firstname, lastname: user.lastname, phone: user.phone });
            return { ...teamMember, id: user.id, firstname: user.firstname, lastname: user.lastname, phone: user.phone };
          }
          return teamMember;
        });

      this.$emit('displayTrainTeam', trainNr, trainTeam);
      return trainTeam;
    },
  },
};
</script>
<style scoped>
.flex-table,
.flex-table > div {
  display: flex;
}

.flex-table {
  flex-direction: row;
  justify-content: flex-end;
}

.text-column {
  width: 100px;
  justify-content: flex-end;
  padding-right: 8px;
}
</style>
